const expand = {
  area: { select: 'id,name' },
  userGroup: { select: 'id,name' },
};

/**
 * OData select/expand for global user-group approvers (by area).
 * Used by createCrudModel via CoreQueries.GlobalUserGroupApproverByArea.
 */
export default {
  paged: {
    select: 'id,approvalLevel',
    notSelectSearch: 'approvalLevel',
    expand,
  },
  item: {
    select: 'id,approvalLevel',
    expand,
  },
  itemDetail: {
    select: 'id,approvalLevel,updated,created',
    expand: {
      ...expand,
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
